<template lang="pug">
  .container
      .simple.authentication-form
        slot(name="header")
        main.auth-container
          .notification.is-info.is-light(v-if="password.success")
            button.delete(type="button" @click="password.success = false; tab = 'signin'")
            | {{ password.success }}
          validation-observer(v-else v-slot="{ invalid }" ref="form")
            h4.subtitle Neues Passwort festlegen
            form(@submit.prevent="submit")
              .panel
                Spinner(v-if="loading" :size="16" :thickness="3")
                .box
                  .form-field
                    validation-provider(name="Passwort" rules="required|zxcvbn:3" v-slot="{ errors }")
                      label.label(for="password") Passwort
                      .control.has-icons-right
                        input#password.input(
                          :type="password.type"
                          name="password"
                          v-model="form.password"
                          :class="{ 'is-danger': errors && errors.length }"
                        )
                        button.icon(
                          v-if="form.password && password.type === 'password'"
                          type="button" @click="password.type = 'text'"
                        )
                          font-awesome-icon(icon="eye")
                        button.icon(
                          v-else-if="form.password && password.type === 'text'"
                          type="button" @click="password.type = 'password'"
                        )
                          font-awesome-icon(icon="eye-slash")
                        span.icon(v-else)
                          font-awesome-icon(icon="key")
                      PasswordStrengthMeter(
                        :password="form.password"
                        @score="score => password.score = score"
                        @feedback="passwordFeedback"
                      )
                      p.help.is-danger(v-if="password.warning || (errors && errors.length)") {{ password.warning || errors[0] }}
                      p.help.has-text-grey(v-else) Pflicht
                    validation-provider(name="score")
                      input#password-score(type="hidden" name="password-score" v-model.number="password.score")
                .buttons.flex.flex-row-reverse
                  button.button.is-primary(type="submit" :disabled="invalid") speichern
</template>

<script>
import Vue from 'vue';
import uniqid from 'uniqid';

import store from '@/store';

import { mapGetters, mapActions, mapMutations } from 'vuex';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import PasswordStrengthMeter from '@/components/PasswordStrengthMeter';

import { translateWarnings } from '@/extensions/restricted-area/helpers/validate';

export default {
  name: 'PasswordResetForm',
  data() {
    let data = {
      error: false,
      loading: false,
      form: {
        password: ''
      },
      password: {
        type: 'password',
        score: 0,
        warning: false,
        success: false,
        suggestions: []
      }
    };

    return data;
  },
  components: {
    PasswordStrengthMeter,
    ValidationObserver,
    ValidationProvider
  },
  computed: {
    email() {
      return this.$route.params.email;
    },
    token() {
      return this.$route.params.token;
    },
    ...mapGetters({
      recaptchaSiteKey: 'googleRecaptchaSiteKey',
      cms: 'CMS'
    })
  },
  methods: {
    async submit() {
      this.error = false;
      this.loading = true;

      let errorMessage = {
        id: uniqid(),
        title: 'Fehler',
        text: 'Es gibt ein technisches Problem.<br>Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
        type: 'error',
        autoclose: 8000
      };

      const valid = await this.$refs.form.validate();
      if (valid && this.recaptchaSiteKey) {
        await this.$recaptchaLoaded();
        try {
          await this.$recaptcha('auth');

          const payload = {
            email: this.email,
            token: this.token,
            cms_id: parseInt(this.cms.id),
            password: this.form.password
          };
          store
            .dispatch('auth/resetPassword', payload)
            .then(() => {
              this.password.success =
                'Ihr Passwort wurde geändert. Sie können sich jetzt mit dem neuen Passwort anmelden.';
              this.form.password = '';
            })
            .catch(error => {
              // eslint-disable-next-line 
              console.error(error);
              this.addMessage(errorMessage);
            })
            .finally(() => {
              this.loading = false;
              this.isReady(true);
            });
        } catch (error) {
          // eslint-disable-next-line 
          console.error(error);
          this.addMessage(errorMessage);
          this.loading = false;
        }
      } else {
        this.loading = false;
        this.addMessage(errorMessage);
      }
    },
    passwordFeedback(feedback) {
      // translateSuggestion
      this.password.warning = translateWarnings(feedback.warning);
    },
    ...mapActions({
      addMessage: 'message/add'
    }),
    ...mapMutations({
      isReady: 'isReady'
    })
  },
  beforeMount() {
    if (this.recaptchaSiteKey) {
      Vue.use(VueReCaptcha, { siteKey: this.recaptchaSiteKey });
    }
  }
};
</script>

<style lang="sass" scoped>
h4.subtitle
  @apply text-center mt-6 mb-2 text-xl
.authentication-form
    max-width: 500px
    margin: auto
.container
    margin: auto
    margin-bottom: 1rem
.password-strength-meter:before, .password-strength-meter:after
    z-index: 5!important
</style>
